import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/posgo-app/Dashboard/Index.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Forgot from "../views/Forgot.vue";
import Password from "../views/Password.vue";
import NotFound from "../views/NotFound.vue";

// Componentes Tracking App
import Tasks from "../views/posgo-app/Tasks/Index.vue";
import TaskCreate from "../views/posgo-app/Tasks/Create.vue";
import TaskEdit from "../views/posgo-app/Tasks/View.vue";

import MyTasks from "../views/posgo-app/Tasks/MyTasks.vue";
import UserRevTasks from "../views/posgo-app/Tasks/UserReview.vue";
import CompleteTask from "../views/posgo-app/Tasks/Complete.vue";
import ReviewTask from "../views/posgo-app/Tasks/Review.vue";
import ImportTask from "../views/posgo-app/Tasks/Import.vue";
import SelfTask from  "../views/posgo-app/Tasks/Self.vue";
// Componentes POSGO-APP



import Clients from "../views/posgo-app/Clients/Index.vue";
import ClientCreate from "../views/posgo-app/Clients/Create.vue";
import ClientEdit from "../views/posgo-app/Clients/Edit.vue";
import ClientExpedient from "../views/posgo-app/Clients/Expediente.vue";
import Loans from "../views/posgo-app/Loans/Index.vue";
import LoanCreate from "../views/posgo-app/Loans/Create.vue";
import LoanView from "../views/posgo-app/Loans/View.vue";
import Products from "../views/posgo-app/Products/Index.vue";
import ProductView from "../views/posgo-app/Products/View.vue";
import ProductCreate from "../views/posgo-app/Products/Create.vue";
import Units from "../views/posgo-app/Configs/Products/Units/Index.vue";
import UnitCreate from "../views/posgo-app/Configs/Products/Units/Create.vue";
import UnitView from "../views/posgo-app/Configs/Products/Units/View.vue";
import Categories from "../views/posgo-app/Configs/Products/Categories/Index.vue";
import CategoryCreate from "../views/posgo-app/Configs/Products/Categories/Create.vue";
import CategoryView from "../views/posgo-app/Configs/Products/Categories/View.vue";
import Company from "../views/posgo-app/Configs/Company/Index.vue";
import Users from "../views/posgo-app/Configs/Users/Index.vue";
import UsersCreate from "../views/posgo-app/Configs/Users/Create.vue";
import UsersView from "../views/posgo-app/Configs/Users/View.vue";
import RolesView from  "../views/posgo-app/Configs/Users/Roles.vue";
import PaymentCreate from "../views/posgo-app/Payments/Create.vue";
import Invoices from "../views/posgo-app/Invoices/Index.vue";
import InvoiceView from "../views/posgo-app/Invoices/View.vue";
import InvoiceCreate from "../views/posgo-app/Invoices/Create.vue";
import CreditNotes from "../views/posgo-app/Invoices/NCIndex.vue";
import CreditNoteView from "../views/posgo-app/Invoices/NCView.vue";
import CreditNoteCreate from "../views/posgo-app/Invoices/NCCreate.vue";
import TasksReports from "../views/posgo-app/Reports/Tasks.vue";
import ExamCreate from "../views/posgo-app/Exams/Create.vue"
import Branches from "../views/posgo-app/Branches/Index.vue";
import BranchesView from "../views/posgo-app/Branches/View.vue";
import BranchesCreate from "../views/posgo-app/Branches/Create.vue";
const routes = [
    {
        path: "/",
        name: "/",
        redirect: "/signin",
    },
    {
        path: "",
        name: "",
        redirect: "/signin",
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: { webOnly: true },
    },
    //Settings
    {
        path: "/settings/company",
        name: "Ajuste de empresa",
        component: Company,
    },
    //Users
    {
        path: "/settings/users",
        name: "Usuarios",
        component: Users,
    },
    {
        path: "/settings/users/create",
        name: "Registrar Usuario",
        component: UsersCreate,
    },
    {
        path: "/settings/users/:id",
        name: "Editar Usuario",
        component: UsersView,
    },
    {
        path: "/settings/users/roles",
        name: "Roles",
        component: RolesView,
    },
    //Tasks
    {
        path: "/tasks/create",
        name: "Crear Tarea",
        component: TaskCreate,
    },
    {
        path: "/tasks/view/:id",
        name: "Editar Tarea",
        component: TaskEdit,
    },
    {
        path: "/tasks/import",
        name: "Importar Tareas",
        component: ImportTask,
    },
    {
        path: "/tasks",
        name: "Tareas",
        component: Tasks,
    },
    {
        path: "/tasks/my",
        name: "Mis Tareas",
        component: MyTasks,
    },
    {
        path: "/tasks/user",
        name: "Tareas Colaborador",
        component: UserRevTasks,
    },
    {
        path: "/tasks/complete/:id",
        name: "Completar Tarea",
        component: CompleteTask,
    },{
       path: "/tasks/self",
       name: "Auto Tarea",
       component: SelfTask,
    },
    {
        path: "/tasks/review/:id",
        name: "Revisar Tarea",
        component: ReviewTask,
    },
    //Clients
    {
        path: "/clients",
        name: "Clientes",
        component: Clients,
    },
    {
        path: "/clients/create",
        name: "Crear Cliente",
        component: ClientCreate,
    },
    {
        path: "/clients/:id",
        name: "Ver Cliente",
        component: ClientEdit,
    },
    {
        path: '/clients/expediente/:id',
        name: 'ClientExpediente',
        component: ClientExpedient,
        props: true
    },
    //Clients
    {
        path: "/config-exam/:id",
        name: "Configuración de exámen",
        component: ExamCreate,
    },

    //Loans
    {
        path: "/loans",
        name: "Créditos",
        component: Loans,
    },
    {
        path: "/create-loan/:id",
        name: "Crear Crédito",
        component: LoanCreate,
    },
    {
        path: "/view-loan/:id",
        name: "Ver Crédito",
        component: LoanView,
    },
    //Products
    {
        path: "/products",
        name: "Productos",
        component: Products,
    },
    {
        path: "/products/create",
        name: "Crear producto",
        component: ProductCreate,
    },
    {
        path: "/products/:id",
        name: "Ver Producto",
        component: ProductView,
    },
    //Units
    {
        path: "/settings/units",
        name: "Unidades de Medida",
        component: Units,
    },
    {
        path: "/settings/units/create",
        name: "Crear Unidad de Medida",
        component: UnitCreate,
    },
    {
        path: "/settings/units/view/:id",
        name: "Ver Unidad de Medida",
        component: UnitView,
    },
    //Categories
    {
        path: "/settings/categories",
        name: "Categorías",
        component: Categories,
    },
    {
        path: "/settings/categories/create",
        name: "Crear Categoría",
        component: CategoryCreate,
    },
    {
        path: "/settings/categories/view/:id",
        name: "Ver Categoría",
        component: CategoryView,
    },
    //Invoices
    {
        path: "/invoices",
        name: "Facturas",
        component: Invoices,
    },
    {
        path: "/invoices/:id",
        name: "Detalle de Factura",
        component: InvoiceView,
    },
    {
        path: "/invoices/create",
        name: "Crear Factura",
        component: InvoiceCreate,
    },
    //Credit Notes
    {
        path: "/invoices/credit_notes",
        name: "Notas de Crédito",
        component: CreditNotes,
    },
    {
        path: "/invoices/credit_note/:id",
        name: "Detalle de Nota de Crédito",
        component: CreditNoteView,
    },
    {
        path: "/invoices/credit_note/create",
        name: "Crear Nota de Crédito",
        component: CreditNoteCreate,
    },
    //Branches
    {
        path: "/branches",
        name: "Sucursales",
        component: Branches,
    },
    {
        path: "/branches/:id",
        name: "Detalle de Sucursal",
        component: BranchesView,
    },
    {
        path: "/branches/create",
        name: "Crear Sucursal",
        component: BranchesCreate,
    },
    //Reports
    {
        path: "/reports/tasks",
        name: "Reportes de Tareas",
        component: TasksReports,
    },
    //Payments
    {
        path: "/create-payment/:id",
        name: "Crear pago",
        component: PaymentCreate,
    },
    //
    {
        path: "/tables",
        name: "Tables",
        component: Tables,
    },
    {
        path: "/billing",
        name: "Billing",
        component: Billing,
    },
    {
        path: "/virtual-reality",
        name: "Virtual Reality",
        component: VirtualReality,
    },
    {
        path: "/rtl-page",
        name: "RTL",
        component: RTL,
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
    },
    {
        path: "/signin",
        name: "Signin",
        component: Signin,
    },
    {
        path: "/signup",
        name: "Signup",
        component: Signup,
    },
    {
        path: "/forgot",
        name: "Forgot",
        component: Forgot,
    },
    {
        path:"/password",
        name:"Password",
        component:Password
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
    },
];


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
    // Definimos las rutas que se pueden ver SIN estar logueado
    const publicPages = ['/signin', '/signup', '/forgot', '/password'];

    // Verificamos si la ruta a la que va el usuario requiere autenticación
    const authRequired = !publicPages.includes(to.path);

    // Verificamos si existe el token en el localStorage
    const loggedIn = localStorage.getItem('accessToken');

    // 1. Si la ruta requiere auth y NO está logueado -> al Signin
    if (authRequired && !loggedIn) {
        return next('/signin');
    }

    // 2. Si ya está logueado e intenta ir al Signin -> mandarlo al Dashboard real
    if (loggedIn && to.path === '/signin') {
        return next('/dashboard');
    }

    // En cualquier otro caso, dejarlo pasar
    next();
});

export default router;